import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { IdsParamSchema } from '../../common/ids-param/ids-param';
import { makeListQuery } from '../../common/list-query/list-query';

/** The whitelisted filters for the roles list (N7). */
export const RolesListQuerySchema = makeListQuery({
  search: z.string().min(1).max(200).optional(),
  isSystem: BooleanParamSchema.optional(),
  /** Resolve-by-ids for the admin `ServerSelect` — see `IdsParamSchema`. */
  ids: IdsParamSchema.optional(),
});

export type RolesListQuery = z.infer<typeof RolesListQuerySchema>;
